import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {Observable} from 'rxjs';

import {Store} from '@ngrx/store';
import * as fromSharedStore from '@jepto/shared/store/index';
import * as fromSharedAccountStore from '@jepto/shared/store/account/index';

import {take, filter} from 'rxjs/operators';

import {getDiffTrialEndCurrentLocalTime} from '@jepto/shared/utils/date';
@Injectable({ providedIn: 'root' })
export class SubscribeGuard implements CanActivate {
	constructor(
		private sharedStore: Store<fromSharedStore.SharedModuleReducers>,
		private router: Router
	) {}

	canActivate() {
		return this.checkTrialValidity();
	}

	checkTrialValidity(): Observable<boolean> {
		return new Observable(observer => {
			this.sharedStore
				.select(fromSharedAccountStore.getAccountData)
				.pipe(
					take(2),
					filter(accountData => accountData !== null)
				)
				.subscribe((accountData: any) => {
					if (accountData.status === 'active') {
						if (
							this.router.url === '/subscribe' ||
							this.router.url === '/resubscribe'
						) {
							this.sharedStore.dispatch(
								new fromSharedStore.Go({ path: ['clients'] })
							);
							observer.next(false);
							observer.complete();
						} else {
							observer.next(true);
							observer.complete();
						}
					} else {
						let diff = getDiffTrialEndCurrentLocalTime(
							accountData.subscription.trialEnd,
							accountData.timezone,
							'minutes'
						);
						if (diff > 0) {
							this.sharedStore.dispatch(
								new fromSharedStore.Go({
									path: ['admin', 'subscription'],
								})
							);
							observer.next(false);
							observer.complete();
						} else {
							observer.next(true);
							observer.complete();
						}
					}
				});
		});
	}
}
